import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IModuleUserFinalGradeQuery } from 'app/library/module-user/interfaces/module-user-final-grade.query.interface';
import { IModuleUserQuery } from 'app/library/module-user/interfaces/module-user.query.interface';
import { ModuleUserExtended } from 'app/library/module-user/models/module-user.extended.model';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { IUserQuery } from 'app/projects/user/src/lib/interfaces/user.query.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface IModuleUsersAndTotalCount {
    data: IModuleUserFinalGradeQuery[];
    pagination: {
        number_of_pages: number;
        number_of_results: number;
    };
    user: IUserQuery;
}

@Injectable()
export class MyModulesService {
    constructor(private http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) private environment: IEnvironment) {}

    getSingle(userId: string, moduleId: string, includeAnalytics?: boolean): Observable<ModuleUserExtended[]> {
        let params = new HttpParams();

        if (includeAnalytics) {
            params = params.set('includeAnalytics', true);
        }

        return this.http
            .get<IModuleUserQuery[]>(`${this.environment.apiUrl}/modules-users?user=${userId}&module=${moduleId}`, { params })
            .pipe(map((queries) => queries.map((moduleUserQuery) => new ModuleUserExtended(moduleUserQuery))));
    }

    getAll(
        userId: string,
        category = '',
        search = '',
        sortBy = 'startDate',
        sortOrder = 'desc',
        pageSize = 20,
        pageIndex = 1,
        tag: number[] = [],
        isParticipant = false,
        isManager = false
    ): Observable<IModuleUsersAndTotalCount> {
        let params = new HttpParams().set('page', pageIndex.toString()).set('limit', pageSize.toString());

        if (sortOrder === '') {
            sortOrder = 'desc';
        }

        if (search) {
            params = params.set('search', search);
        }

        if (sortBy && sortOrder) {
            params = params.set('sortBy', sortBy);
            params = params.set('sortOrder', sortOrder);
        }

        if (tag.length) {
            params = params.set('filter[tag]', tag.toString());
        }

        if (category) {
            params = params.set('filter[category]', category);

            if (category === 'pinned') {
                if (isParticipant) {
                    params = params.set('filter[isParticipant]', isParticipant.toString());
                }
                if (isManager) {
                    params = params.set('filter[isManager]', isManager.toString());
                }
            }
        }

        return this.http.get<IModuleUsersAndTotalCount>(`${this.environment.apiUrl}/users/${userId}/modules`, { params });
    }
}
